import { render } from "./respostas.vue?vue&type=template&id=5758f79d&scoped=true"
import script from "./respostas.vue?vue&type=script&lang=js"
export * from "./respostas.vue?vue&type=script&lang=js"

import "./respostas.vue?vue&type=style&index=0&id=5758f79d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5758f79d"]])

export default __exports__